import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Sidebar from '../../components/SideBar';
import NavBar from '../../components/NavBarSearchSong';
import Settings from '../../assets/Settings.png';
import RoundButton from '../../components/RoundButton';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import search from '../../assets/ic_search.png';
import {
  _showAlert,
  formatDateToDisplay,
  getWeekDays,
  getShortNamesOfWeekDays,
  getSchedulesFromPlaylist,
  getDaysNameFromArrayIndex,
} from '../../utils';
import './EditCustomerScheduler.scss';
import { LoaderSpinner } from '../../components';
import AlertModal from '../../components/Modal';
import SortIndicator from '../../components/SortIndicator';
import { Button, Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import Popup from '../../components/Popup';
import EditPlaylistSecondery from '../EditPlaylistSecondery';
import PlaylistCopySongsDialog from '../../components/PlaylistManagement/PlaylistCopySongsDialog';
import PlaylistActionIcon from '../../components/PlaylistManagement/PlaylistActionIcon';
import { fetcher } from '../../utils/axios';
import { MEDIA_URL } from '../../utils/consts';
import { conflictingDays, updatedPlaylistSchedule, withoutSchedule, sameSchedule } from './scheduleUtils';

const useStyles = makeStyles({
  table: {
    //   minWidth: 700,
    borderRadius: 30,
  },
});

const HOURS = Array.from({ length: 24 }, (_, i) => (i.toString().length === 1 ? '0' + i : i.toString()));
const MINUTES = Array.from({ length: 60 }, (_, i) => (i.toString().length === 1 ? '0' + i : i.toString()));

function EditCustomerSecular(props) {
  const classes = useStyles();
  const isAdmin = JSON.parse(sessionStorage.getItem('authData'))?.user?.userRole === 1;
  const [selectedCustomer, setSelectedCustomer] = useState({});
  const [searchInput, setSearchInput] = useState('');
  const [selectedPlaylistToUpload, setPlaylistToUpload] = useState([]);
  const [hour, setHour] = useState('00');
  const [minute, setMinute] = useState('00');
  const [selectedWeekDays, setWeekDays] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [customerAllPlaylist, setCustomerAllPlaylist] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [selectedPlaylist, setSelectedPlaylist] = useState(null);
  const [schedulesList, setSchedulesList] = useState([]);
  const [previewPlaylist, setPreviewPlaylist] = useState(null);
  const [previewIndex, setPreviewIndex] = useState(0);
  const [viewingPlaylist, setViewingPlaylist] = useState(false);
  const [playbackError, setPlaybackError] = useState('');
  const [editingPlaylist, setEditingPlaylist] = useState(null);
  const [copyDialogPlaylist, setCopyDialogPlaylist] = useState(null);
  const [editingSchedule, setEditingSchedule] = useState(null);
  const [loadingPlaylistId, setLoadingPlaylistId] = useState(null);

  // Sorting states
  const [playlistSortConfig, setPlaylistSortConfig] = useState({ key: null, direction: 'asc' });
  const [scheduleSortConfig, setScheduleSortConfig] = useState({ key: null, direction: 'asc' });

  const dispatch = useDispatch();

  const handleSort = (key, sortConfig, setSortConfig) => {
    let direction = 'desc';
    let newKey = key;

    if (sortConfig.key === key) {
      if (sortConfig.direction === 'desc') {
        direction = 'asc';
      } else {
        newKey = null;
      }
    }

    setSortConfig({ key: newKey, direction });
  };

  const sortData = (data, sortConfig) => {
    if (!sortConfig.key || !Array.isArray(data)) return data;

    return [...data].sort((a, b) => {
      const valueA = (a[sortConfig.key] || '').toString();
      const valueB = (b[sortConfig.key] || '').toString();

      return sortConfig.direction === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
    });
  };

  /**
   * Close Modal
   */
  const handleClose = () => {
    setOpen(false);
  };

  /**
   * getting state from redux store
   */
  const { deleteCustomerSchedule, getCustomerPlaylist, scheduleCustomerSong } = useSelector((state) => ({
    deleteCustomerSchedule: state.deleteCustomerSchedule.result,
    getCustomerPlaylist: state.getCustomerPlaylist.result,
    scheduleCustomerSong: state.scheduleCustomerSong.result,
  }));
  /**
   * call the get customer playlist api
   * watch the local state selectedCustomer changes to search the playlist
   */
  useEffect(() => {
    fetchCustomerPlaylist();
  }, [selectedCustomer]);

  /**
   * check the router params
   */
  useEffect(() => {
    if (props?.history?.location?.state) {
      setSelectedCustomer(props.history.location.state);
    }
  }, [props.history]);

  /**
   * get all playlist for customer handler
   * watch the state chagnes of the getCustomerPlaylist state
   */
  useEffect(() => {
    if (Array.isArray(getCustomerPlaylist)) {
      setCustomerAllPlaylist(getCustomerPlaylist.filter((playlist) =>
        playlist.name?.toLowerCase().includes(searchInput.toLowerCase())));
      setSchedulesList(getSchedulesFromPlaylist(getCustomerPlaylist));
    }
    if (getCustomerPlaylist?.error) {
      _showAlert(getCustomerPlaylist?.error, 'error', 8000);
    }
  }, [getCustomerPlaylist, searchInput]);

  /**
   * delete scheduler api handler
   * delete scheduler state watcher
   */
  useEffect(() => {
    if (deleteCustomerSchedule?.status === 200) {
      fetchCustomerPlaylist();
      _showAlert('Deleted Successfully', 'success');
      setLoading(false);
    }
    if (deleteCustomerSchedule?.error) {
      setLoading(false);
      _showAlert(deleteCustomerSchedule?.error, 'error', 8000);
    }
  }, [deleteCustomerSchedule]);

  /**
   * scheduleCustomerSong api handler
   * scheduleCustomerSong state watcher
   */
  useEffect(() => {
    if (scheduleCustomerSong?.status === 200) {
      fetchCustomerPlaylist();
      _showAlert('Schedule Updated Successfully', 'success', 6000);
      setPlaylistToUpload([]);
      setHour('00');
      setMinute('00');
      setWeekDays([]);
      setEditingSchedule(null);
      setLoading(false);
    }
    if (scheduleCustomerSong?.error) {
      _showAlert(scheduleCustomerSong.error, 'error');
      setLoading(false);
    }
  }, [scheduleCustomerSong]);

  const fetchCustomerPlaylist = () => {
    selectedCustomer.id && dispatch({ type: 'GET_CUSTOMER_PLAYLIST', payload: { customerId: selectedCustomer.id } });
  };

  const handleEditCustomerPlaylist = () => {
    props.history.push({
      pathname: '/edit-customer-playlists',
      state: selectedCustomer,
    });
  };

  const handleSelectSongsToUpload = (event, playlist) => {
    if (editingSchedule) return;
    let checked = event.target.checked;
    if (checked) {
      setPlaylistToUpload([playlist.id]);
    } else {
      setPlaylistToUpload([]);
    }
  };

  const handleAddPlaylistToCustomer = () => {
    const time = `${hour}:${minute}`;
    let playlistToUpload = customerAllPlaylist.find((item) => item.id === selectedPlaylistToUpload[0]);
    if (editingSchedule) {
      playlistToUpload = getCustomerPlaylist.find((item) => item.id === editingSchedule.playlistId);
    }
    if (!playlistToUpload) {
      _showAlert(`Please select playlist to continue`, 'error', 10000);
      return;
    }
    if (!selectedWeekDays?.length) {
      _showAlert(`Please select days to continue`, 'error', 10000);
      return;
    }
    const duplicateDays = conflictingDays(schedulesList, time, selectedWeekDays, editingSchedule);
    if (duplicateDays.length) {
      _showAlert(`${getDaysNameFromArrayIndex(duplicateDays)} already scheduled for time ${time}`, 'error', 10000);
      return;
    }
    const schedule = updatedPlaylistSchedule(playlistToUpload.schedule, selectedWeekDays, time, editingSchedule);
    if (!schedule) {
      _showAlert('This schedule changed. Please refresh and try again.', 'error');
      return;
    }
    setLoading(true);
    dispatch({
      type: 'SCHEDULE_CUSTOMER_SONG',
      payload: {
        customerId: selectedCustomer.id,
        playlistId: playlistToUpload.id,
        schedule,
      },
    });
  };

  const handleDeleteCustomerSchedule = (playlist) => {
    setOpen(false);
    let playlistToUpload = getCustomerPlaylist.find((item) => item.id === playlist.playlistId);
    if (!playlistToUpload || !Array.isArray(playlistToUpload.schedule)) {
      _showAlert('This schedule changed. Please refresh and try again.', 'error');
      return;
    }
    setLoading(true);
    const newSchedules = withoutSchedule(playlistToUpload.schedule, playlist);
    if (editingSchedule && editingSchedule.playlistId === playlist.playlistId && sameSchedule(editingSchedule, playlist)) {
      cancelScheduleEdit();
    }
    if (newSchedules.length) {
      dispatch({
        type: 'SCHEDULE_CUSTOMER_SONG',
        payload: { customerId: selectedCustomer.id, playlistId: playlist.playlistId, schedule: newSchedules },
      });
    } else {
      dispatch({
        type: 'DELETE_CUSTOMER_SCHEDULE',
        payload: { customerId: selectedCustomer.id, playlistId: playlist.playlistId },
      });
    }
  };

  const startScheduleEdit = (item) => {
    setEditingSchedule({ ...item, days: [...item.days] });
    setPlaylistToUpload([item.playlistId]);
    setWeekDays([...item.days]);
    const [nextHour, nextMinute] = item.time.split(':');
    setHour(nextHour);
    setMinute(nextMinute);
  };

  const cancelScheduleEdit = () => {
    setEditingSchedule(null);
    setPlaylistToUpload([]);
    setWeekDays([]);
    setHour('00');
    setMinute('00');
  };

  const openPlaylist = async (playlistId, action) => {
    if (loadingPlaylistId) return;
    setLoadingPlaylistId(playlistId);
    try {
      const playlists = await fetcher('/playlists/');
      const playlist = playlists.find((item) => item.id === playlistId);
      if (!playlist) throw new Error('Playlist not found');
      if (action === 'edit') {
        setEditingPlaylist(playlist);
      } else if (action === 'copy') {
        setCopyDialogPlaylist(playlist);
      } else {
        setPreviewPlaylist(playlist);
        setPreviewIndex(0);
        setPlaybackError('');
        setViewingPlaylist(true);
      }
    } catch (error) {
      _showAlert('Could not load this playlist. Please try again.', 'error');
    } finally {
      setLoadingPlaylistId(null);
    }
  };

  const playlistActionButtons = (playlist, isScheduled = false) => <div className="scheduler-playlist-actions">
    <PlaylistActionIcon kind="listen" label={`Listen to ${playlist.name}`} onClick={() => openPlaylist(isScheduled ? playlist.playlistId : playlist.id, 'listen')} disabled={!!loadingPlaylistId} />
    <PlaylistActionIcon kind="copy" label={`Copy songs from ${playlist.name}`} onClick={() => openPlaylist(isScheduled ? playlist.playlistId : playlist.id, 'copy')} disabled={!!loadingPlaylistId} />
    <PlaylistActionIcon kind="edit" label={`Edit ${playlist.name}`} onClick={() => openPlaylist(isScheduled ? playlist.playlistId : playlist.id, 'edit')} disabled={!!loadingPlaylistId} />
    {isScheduled && isAdmin && <PlaylistActionIcon kind="schedule" label={`Edit schedule for ${playlist.name}`} onClick={() => startScheduleEdit(playlist)} />}
    {isScheduled && isAdmin && <PlaylistActionIcon kind="remove" label={`Delete schedule for ${playlist.name}`} onClick={() => {
      setOpen(true);
      setSelectedPlaylist(playlist);
    }} />}
  </div>;

  const handleChangeWeekDays = (event, day) => {
    if (event.target.checked) {
      setWeekDays([...selectedWeekDays, day.value]);
    } else {
      setWeekDays(selectedWeekDays.filter((item) => item !== day.value));
    }
  };

  const getCustomerName = (customer) => {
    if (customer.name) {
      return customer.name;
    } else {
      let name = '';
      name = customer.firstname || '';
      name = name + ' ' + customer.lastname || '';
      return name || 'N/A';
    }
  };

  const handleSearchInput = (value) => {
    setSearchInput(value);
  };

  /**
   * get called on component unmount
   * clear the redux state of the component
   */
  useEffect(() => {
    return () => {
      dispatch({ type: 'CLEAR_STATE', actionName: 'SCHEDULE_CUSTOMER_SONG' });
      dispatch({ type: 'CLEAR_STATE', actionName: 'DELETE_CUSTOMER_SCHEDULE' });
    };
  }, []);

  return (
    <div className="main">
      {isLoading ? <LoaderSpinner /> : null}
      <div className="sidebar">
        <Sidebar />
      </div>
      <AlertModal open={open} onClose={handleClose} handelDelete={() => handleDeleteCustomerSchedule(selectedPlaylist)} />
      <div className="leftPortion">
        <NavBar data="All Customers" icon={Settings} currentRouteName="Customers" breadcrumbsPath="Edit Customer Scheduler" />
        <div className="content">
          <div className="warp_edit_row">
            <div className="editRow">
              <div className="wrap_edit">
                <p>Edit:</p>
                <RoundButton className="disabled-button" btnText="Playlist" handleClick={handleEditCustomerPlaylist} />
                <RoundButton btnText="Scheduler" />
              </div>
            </div>
          </div>

          <TableContainer className="tbl_wraper" component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Customer Name</TableCell>
                  <TableCell>Royalty Type</TableCell>
                  <TableCell>Business Name</TableCell>
                  <TableCell>Address</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell className="text_center">Connection</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>{getCustomerName(selectedCustomer)}</TableCell>
                  <TableCell>{selectedCustomer.royalty_only ? 'Royalty' : 'Free (UnRoyalty)'}</TableCell>
                  <TableCell>{selectedCustomer.business_name || 'N/A'}</TableCell>
                  <TableCell>{selectedCustomer.address || 'N/A'}</TableCell>
                  <TableCell>{selectedCustomer.email}</TableCell>
                  <TableCell>{formatDateToDisplay(selectedCustomer.createdAt)}</TableCell>
                  <TableCell>
                    <span className="gray_circle"></span>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <div className="wrap_tbl custmr_tbl">
            <div className="wrap_tbl_lft">
              <TableContainer className="tbl_wraper" component={Paper}>
                <Table className={classes.table} stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell 
                        onClick={() => handleSort('name', playlistSortConfig, setPlaylistSortConfig)}
                        style={{ cursor: 'pointer', userSelect: 'none' }}
                        colspan="3"
                      >
                        <div className="search_row wdth100">
                          <input
                            className="input_field"
                            placeholder="Search something here..."
                            type="text"
                            value={searchInput}
                            onChange={(e) => handleSearchInput(e.target.value)}
                            name="searchInput"
                            onClick={(e) => e.stopPropagation()}
                          />
                          <img src={search} />
                        </div>
                        <div style={{ marginTop: '8px', display: 'flex', alignItems: 'center' }}>
                          Playlist Name<SortIndicator sortConfig={playlistSortConfig} columnKey="name" />
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {sortData(customerAllPlaylist, playlistSortConfig).map((playlist, index) => (
                      <TableRow key={playlist.id}>
                        {isAdmin && <TableCell>
                          <Checkbox
                            checked={selectedPlaylistToUpload.includes(playlist.id)}
                            onChange={(event) => handleSelectSongsToUpload(event, playlist)}
                            disabled={!!editingSchedule}
                            color="primary"
                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                          />
                        </TableCell>}
                        <TableCell style={{ fontWeight: 'bold' }}>#{++index}</TableCell>
                        <TableCell>{playlist.name}</TableCell>
                        <TableCell>{playlistActionButtons(playlist)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              {isAdmin && <div className="days_row">
                {editingSchedule && <p className="scheduler-editing-label">Editing schedule for {editingSchedule.name}</p>}
                <p>Date:</p>
                <ul>
                  {getWeekDays().map((item) => {
                    return (
                      <li key={item.value}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedWeekDays.includes(item.value) || false}
                              name={item.name}
                              onChange={(event) => handleChangeWeekDays(event, item)}
                            />
                          }
                          label={item.label}
                        />
                      </li>
                    );
                  })}
                </ul>
                <div className="time_add_row">
                  <span className="time_row">
                    <p>Time:</p>
                    <select placeholder="00" name="hour" value={hour} required onChange={(event) => setHour(event.target.value)}>
                      {HOURS.map((item) => (
                        <option key={item} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                    <select placeholder="00" name="minute" value={minute} required onChange={(event) => setMinute(event.target.value)}>
                      {MINUTES.map((item) => (
                        <option key={item} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </span>
                  <div className="scheduler-form-actions">
                    {editingSchedule && <Button onClick={cancelScheduleEdit}>Cancel</Button>}
                    <RoundButton handleClick={handleAddPlaylistToCustomer} btnText={editingSchedule ? 'Save Schedule' : 'Add'} />
                  </div>
                </div>
              </div>}
            </div>

            <TableContainer className="tbl_wraper result_playlist" component={Paper}>
              <Table className={classes.table} stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell className="table_font">Result</TableCell>
                    <TableCell
                      onClick={() => handleSort('name', scheduleSortConfig, setScheduleSortConfig)}
                      style={{ cursor: 'pointer', userSelect: 'none' }}
                    >
                      Playlist<SortIndicator sortConfig={scheduleSortConfig} columnKey="name" />
                    </TableCell>
                    <TableCell>Days</TableCell>
                    <TableCell
                      onClick={() => handleSort('time', scheduleSortConfig, setScheduleSortConfig)}
                      style={{ cursor: 'pointer', userSelect: 'none' }}
                    >
                      Time<SortIndicator sortConfig={scheduleSortConfig} columnKey="time" />
                    </TableCell>
                    <TableCell className="text_center">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(schedulesList) &&
                    sortData(schedulesList, scheduleSortConfig).map((scheduleItem, index) => (
                      <TableRow key={index}>
                        <TableCell style={{ fontWeight: 'bold' }}>#{++index}</TableCell>
                        <TableCell>{scheduleItem.name || 'N/A'}</TableCell>
                        <TableCell>{getShortNamesOfWeekDays([...scheduleItem.days])}</TableCell>
                        <TableCell>{scheduleItem.time}</TableCell>
                        <TableCell>
                          {playlistActionButtons(scheduleItem, true)}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
      <Dialog className="playlist-management-dialog" open={viewingPlaylist} onClose={() => { setViewingPlaylist(false); setPreviewPlaylist(null); }} maxWidth={false}>
        <DialogTitle>Songs in {previewPlaylist?.name}</DialogTitle>
        <DialogContent>
          <p className="playlist-management-description">Listen to the songs in this playlist, or open its editor to make changes.</p>
          {previewPlaylist?.songs?.[previewIndex] && <audio
            className="scheduler-audio-player"
            key={`${previewPlaylist.id}-${previewIndex}`}
            src={`${MEDIA_URL}songs/${previewPlaylist.songs[previewIndex].id}.mp3`}
            controls
            autoPlay
            onError={() => setPlaybackError('Could not play this song. Please try another song.')}
            onEnded={() => {
              if (previewIndex < previewPlaylist.songs.length - 1) {
                setPlaybackError('');
                setPreviewIndex((index) => index + 1);
              }
            }}
          />}
          {playbackError && <p className="scheduler-playback-error" role="alert">{playbackError}</p>}
          <div className="playlist-management-list scheduler-song-list">
            {(previewPlaylist?.songs || []).map((song, index) => <div className="playlist-management-row scheduler-song-row" key={song.id}>
              <span>{index + 1}. {song.name || song.title || song.fileName || 'Unnamed song'}{song.artist ? ` — ${song.artist}` : ''}</span>
              <PlaylistActionIcon kind="listen" label={`${previewIndex === index ? 'Playing' : 'Play'} ${song.name || song.title || song.fileName || 'song'}`} onClick={() => { setPlaybackError(''); setPreviewIndex(index); }} active={previewIndex === index} />
            </div>)}
            {!previewPlaylist?.songs?.length && <p>This playlist has no songs.</p>}
          </div>
          <div className="playlist-management-footer">
            <Button onClick={() => { setViewingPlaylist(false); setPreviewPlaylist(null); }}>Close</Button>
            <Button color="primary" variant="contained" onClick={() => { setViewingPlaylist(false); setPreviewPlaylist(null); setEditingPlaylist(previewPlaylist); }}>Edit playlist</Button>
          </div>
        </DialogContent>
      </Dialog>
      {!!editingPlaylist && <Popup
        open={!!editingPlaylist}
        onClose={() => setEditingPlaylist(null)}
        dialogClassName="scheduler-edit-playlist-dialog"
      >
        <EditPlaylistSecondery
          {...props}
          isPageOpenedAsPopup={true}
          selectedPlaylistForPopup={editingPlaylist}
          onSavePlaylist={() => { setEditingPlaylist(null); fetchCustomerPlaylist(); }}
          isPlaylistRoyalty={editingPlaylist.type === 3}
        />
      </Popup>}
      <PlaylistCopySongsDialog
        playlist={copyDialogPlaylist}
        open={!!copyDialogPlaylist}
        onClose={() => setCopyDialogPlaylist(null)}
        onSuccess={fetchCustomerPlaylist}
      />
    </div>
  );
}
export default EditCustomerSecular;
